module.exports = __webpack_public_path__ + "img/calendar.2955e104.svg";